import { GFAFundRaising } from "@dune/types";
import { Button, ControlledInput, Input } from "@dune/ui";
import { Plus, Trash2 } from "lucide-react";
import { useFormContext } from "react-hook-form";

interface GFAFinancingFundRaisingsContainerProps {
	isForm?: boolean;
}

const GFAFinancingFundRaisingsContainer = ({
	isForm = true,
}: GFAFinancingFundRaisingsContainerProps) => {
	const { control, setValue } = useFormContext();
	const { watch } = useFormContext();
	const fundRaisings = watch("fundRaisings");
	return (
		<div className="flex flex-col gap-4">
			{isForm && (
				<div className="flex flex-row gap-4">
					<h1 className="text-[#144C65] text-lg font-medium">
						GRILLE D'APPEL DE FONDS
					</h1>
				</div>
			)}
			<div className="border rounded-lg p-4 flex flex-col gap-4">
				<div className="flex flex-col gap-4">
					<div className="flex flex-row gap-4 w-[95%]">
						<div className="w-1/3">Stade</div>
						<div className="w-1/3">%</div>
						<div className="w-1/3">Cumul</div>
					</div>
					{fundRaisings?.map((fundRaising: GFAFundRaising, index: number) => (
						<div
							key={fundRaising.id}
							className="flex flex-row gap-4 items-center"
						>
							<div className="flex flex-row gap-4 w-[95%]">
								<div className="w-1/3">
									<ControlledInput
										name={`fundRaisings.${index}.name`}
										control={control}
										disabled={!isForm}
									/>
								</div>

								<div className="w-1/3">
									<ControlledInput
										name={`fundRaisings.${index}.percentage`}
										control={control}
										type="number"
										iconOrText="%"
										iconOrTextPosition="right"
										disabled={!isForm}
									/>
								</div>

								<div className="w-1/3">
									<Input
										disabled={true}
										value={
											fundRaisings
												.slice(0, index + 1)
												.reduce(
													(acc: number, fundRaising: GFAFundRaising) =>
														acc + Number(fundRaising.percentage),
													0,
												) || null
										}
									/>
								</div>
							</div>
							{isForm && (
								<Trash2
									onClick={() => {
										setValue("fundRaisings", [
											...fundRaisings.slice(0, index),
											...fundRaisings.slice(index + 1),
										]);
									}}
								/>
							)}
						</div>
					))}
					{isForm && (
						<Button
							onClick={() => {
								setValue("fundRaisings", [
									...fundRaisings,
									{ id: fundRaisings.length + 1 },
								]);
							}}
							variant="none"
							size="none"
							className="self-start"
							type="button"
						>
							<div className="flex flex-row items-center gap-2 font-medium text-sm text-primary">
								<Plus /> Ajouter
							</div>
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default GFAFinancingFundRaisingsContainer;
